module.exports = __webpack_public_path__ + "img/gal_27.c6a45b5b.png";